import { useApiClient } from "../../../../common/apiclients";
import {
  BasicQuestionnaireViewModel,
  QuestionnairesClient,
} from "../../../../common/client";
import { useEffect, useState } from "react";
import { Button, Link } from "@material-ui/core";
import { questionnaireHref } from "../../Routes";

export function QuestionnaireList() {
  const client = useApiClient(QuestionnairesClient);
  const [questionnaires, setQuestionnaires] =
    useState<BasicQuestionnaireViewModel[]>();

  useEffect(() => {
    loadQuestionnaires();
  }, []);

  return questionnaires ? showQuestionnaires(questionnaires) : <div />;

  function showQuestionnaires(list: BasicQuestionnaireViewModel[]) {
    return (
        <>
            <h2>Published</h2>
                <ul>
                    {list.filter(q => q.published === true).map((q) => (
                        <li>
                            <Button onClick={() => publishQuestionnaire(q.id)} size='small'>Unpublish</Button>
                            <Button style={{ marginRight: '10px' }} onClick={() => duplicateQuestionnaire(q.id)} size='small'>Duplicate</Button>
                            <Link href={questionnaireHref(q.id)}>{q.name}</Link>
                        </li>
                    ))}
                </ul>
            <h2>Drafts</h2>
            <ul>
                {list.filter(q => q.published === false).map((q) => (
                    <li>
                        <Button onClick={() => publishQuestionnaire(q.id)} size='small'>Publish</Button>
                        <Button onClick={() => duplicateQuestionnaire(q.id)} size='small'>Duplicate</Button>
                        {/*<Button style={{ marginRight: '10px' }} onClick={() => deleteQuestionnaire(q.id)} size='small'>Delete</Button>*/}
                        <Link href={questionnaireHref(q.id)}>{q.name}</Link>
                    </li>
                ))}
            </ul>
        </>
    );
  }

  async function loadQuestionnaires() {
    setQuestionnaires(await client.getQuestionnaires());
  }

    async function deleteQuestionnaire(id: string) {
        const questionnaire = await client.getQuestionnaire(id);
        questionnaire.questions.forEach((question) => {
            deleteQuestion(id, question.id);
        });
        loadQuestionnaires();
    }

    async function deleteQuestion(id: string, questionID: string) {
        await client.deleteQuestion(id, questionID);
    }

    async function duplicateQuestionnaire(id:string) {
        await client.cloneQuestionnaire(id);
        loadQuestionnaires();
    }

    async function publishQuestionnaire(id: string) {
        await client.publishQuestionnaire(id);
        loadQuestionnaires();
    }
}
